/*
 * Tupaia
 * Copyright (c) 2017 - 2020 Beyond Essential Systems Pty Ltd
 */
import React from "react";
import styled from "styled-components";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import MuiContainer from "@material-ui/core/Container";
import { FlexEnd } from "./Layout";

const Container = styled(MuiContainer)`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 50px;
    padding-right: 50px;
  }
`;

const FooterInner = styled(FlexEnd)`
  color: white;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 1rem;
  padding-bottom: 1rem;
`;

const INFO_LINK = "https://www.beyondessential.com.au/tupaia";

export const Footer = () => {
  return (
    <Container maxWidth={false}>
      <FooterInner>
        <Typography>
          Powered by{" "}
          <Link href={INFO_LINK} color="inherit" underline="always">
            Tupaia
          </Link>
        </Typography>
      </FooterInner>
    </Container>
  );
};
